/**
 * SCD Lot 3 — Catalogue d'événements retail, branché sur le MOTEUR
 * d'événements du noyau commun (eventSlice, EventPopup, generateRandomEvent).
 * Les événements sont définis dans /data/dgs/evenements_retail.json au
 * format attendu par le moteur. Chaque événement porte `retail: true`
 * (gate : ne se déclenche que si un magasin est actif) et ses choix
 * peuvent porter `appliesRetailEffect` (cf. utils/retailMarketing.js).
 */
import retailEventsData from './dgs/evenements_retail.json';

export const EVENTS = retailEventsData.evenements;

export const getEventById = (id) => EVENTS.find(e => e.id === id);
